import React, { Component } from 'react';
import './categories.scss';
import CategoryItem from './category-item';

interface CategoriesProp {
  categories: any[];
}

class Categories extends Component<CategoriesProp> {
  render() {
    return (
      <div className={"categories-container" + (this.props.categories?.length > 0 ? " has-content" : "")}>
        {this.props.categories.map((category) => (
          <div className="category-wrap" key={category.id}>
            <CategoryItem item={category} />
          </div>
        ))}
      </div>
    );
  }
}

export default Categories;
